import React, { useEffect, useState } from "react";
import {
  CustomConfirmModal,
  PaginationDropdown,
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import {
  ChevronsRightIcon,
  Edit,
  Trash,
  Minus,
  Plus,
  Download,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Pagination } from "@mui/material";

import GeneralFooter from "../common/GeneralFooter";
import PermissionButton from "../common/PermissionButton";

import { fetchData } from "../../utils/functions";
import "font-awesome/css/font-awesome.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

const Wash = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];
  const [washData, setWashData] = useState([]);

  const [selectedWash, setSelectedWash] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [isApproveModalVisible, setApproveModalVisible] = useState(false);
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isRemarksModalVisible, setRemarksModalVisible] = useState(false);
  const [isViewRemarksModalVisible, setViewRemarksModalVisible] =
    useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [selectedRejectId, setSelectedRejectId] = useState(null);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [selectedApproveId, setSelectedApproveId] = useState(null);
  const [selectedWashForRemarks, setSelectedWashForRemarks] = useState(null);
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [filterReset, setFilterReset] = useState(0);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [appliedDistrict, setAppliedDistrict] = useState(null);
  const [tehsils, setTehsils] = useState([]);
  const [selectedTehsil, setSelectedTehsil] = useState(null);
  const [appliedTehsil, setAppliedTehsil] = useState(null);
  const [ucs, setUcs] = useState([]);
  const [selectedUc, setSelectedUc] = useState(null);
  const [appliedUc, setAppliedUc] = useState(null);
  const [dehs, setDehs] = useState([]);
  const [selectedDeh, setSelectedDeh] = useState(null);
  const [appliedDeh, setAppliedDeh] = useState(null);
  const [villages, setVillages] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState(null);
  const [appliedVillages, setAppliedVillages] = useState(null);
  const [selectedDqaStatus, setSelectedDqaStatus] = useState(null);
  const [appliedDqaStatus, setAppliedDqaStatus] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [dateField, setDateField] = useState("");
  const [condition, setCondition] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedDateField, setAppliedDateField] = useState(null);
  const [appliedCondition, setAppliedCondition] = useState(null);
  const [appliedDateValue, setAppliedDateValue] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState(null);
  const [appliedEndDate, setAppliedEndDate] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_records: 0,
    total_pages: 0,
  });

  const getLatestRemarks = (wash) => {
    if (wash.auditLogs && wash.auditLogs.length > 0) {
      try {
        const latestAudit = wash.auditLogs[0];
        const newValue = JSON.parse(latestAudit.newvalue);
        return newValue.remarks || wash.remarks || "No remarks";
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
        return wash.remarks || "No remarks";
      }
    }
    return wash.remarks || wash.rejection_remarks || "No remarks";
  };
  const getRemarksHistory = (wash) => {
    if (!wash.auditLogs || wash.auditLogs.length === 0) {
      return [];
    }

    const history = [];
    wash.auditLogs.forEach((log, index) => {
      try {
        const newValue = JSON.parse(log.newvalue);
        const oldValue = log.oldvalue ? JSON.parse(log.oldvalue) : null;

        history.push({
          action: log.action,
          date: log.createdAt,
          from: oldValue?.remarks || "None",
          to: newValue.remarks,
          userId: log.userId,
          userName: log.user.name,
        });
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
      }
    });

    return history;
  };
  const showRemarksDialog = (wash) => {
    setSelectedWashForRemarks(wash);
    setViewRemarksModalVisible(true);
  };
  const closeRemarksDialog = () => {
    setViewRemarksModalVisible(false);
    setSelectedWashForRemarks(null);
  };

  const validateRemarks = (remarksText) => {
    if (!remarksText.trim()) {
      return "Remarks are required";
    }
    if (remarksText.trim().length < 10) {
      return "Remarks must be at least 10 characters long";
    }
    if (remarksText.trim().length > 255) {
      return "Remarks cannot exceed 255 characters";
    }
    return "";
  };

  const handleRemarksChange = (value) => {
    setRemarks(value);
    if (remarksError) {
      const error = validateRemarks(value);
      setRemarksError(error);
    }
  };

  const hasFiltersApplied =
    appliedDistrict ||
    appliedTehsil ||
    appliedUc ||
    appliedDeh ||
    appliedVillages ||
    appliedCondition ||
    appliedDqaStatus;

  const hasDataToExport = washData.length > 0;

  const dateFieldsOptions = [
    { value: "date_time_of_survey", label: "Date of Survey" },
  ];

  const dqaStatusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
  ];

  const conditions = [
    { value: "lt", label: "Less Than" },
    { value: "gt", label: "Greater Than" },
    { value: "equals", label: "Equal To" },
    { value: "between", label: "Between" },
  ];

  const toggleFilters = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const handleApply = () => {
    if (condition && !dateField) {
      toast.error("Please select a date field when using a condition");
      return;
    }

    if (condition === "between") {
      if (!startDate || !endDate) {
        toast.error(
          "Please provide both start and end dates for 'between' condition"
        );
        return;
      }
    }

    if (condition && condition !== "between" && !dateValue) {
      toast.error("Please provide a date value for the selected condition");
      return;
    }

    setAppliedDistrict(selectedDistrict);
    setAppliedTehsil(selectedTehsil);
    setAppliedUc(selectedUc);
    setAppliedDeh(selectedDeh);
    setAppliedVillages(selectedVillages);
    setAppliedDqaStatus(selectedDqaStatus);
    setAppliedDateField(dateField);
    setAppliedCondition(condition);
    if (condition === "between") {
      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
      setAppliedDateValue(null);
    } else {
      setAppliedDateValue(dateValue);
      setAppliedStartDate(null);
      setAppliedEndDate(null);
    }
    setPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  const handleClear = () => {
    setSelectedDistrict(null);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setSelectedDqaStatus(null);
    setAppliedDistrict(null);
    setAppliedTehsil(null);
    setAppliedUc(null);
    setAppliedDeh(null);
    setAppliedVillages(null);
    setAppliedDqaStatus(null);
    setAppliedDateField(null);
    setAppliedCondition(null);
    setAppliedDateValue(null);
    setAppliedStartDate(null);
    setAppliedEndDate(null);
    setDateField("");
    setCondition("");
    setDateValue("");
    setStartDate("");
    setEndDate("");
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
    setPagination((prev) => ({ ...prev, current_page: 1 }));
    setFilterReset((prev) => prev + 1);
  };

  const handleDistrictChange = (selected) => {
    setSelectedDistrict(selected);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleTehsilChange = (selected) => {
    setSelectedTehsil(selected);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleDehChange = (selected) => {
    setSelectedDeh(selected);
    setSelectedVillages(null);
    setVillages([]);
  };

  const handleVillageChange = (selected) => {
    setSelectedVillages(selected);
  };

  const handleFilterChange = (key, value) => {
    switch (key) {
      case "dateField":
        setDateField(value);
        if (value === "") {
          setCondition("");
          setDateValue("");
          setStartDate("");
          setEndDate("");
        }
        break;
      case "condition":
        setCondition(value);
        if (value !== "between") {
          setStartDate("");
          setEndDate("");
        } else {
          setDateValue("");
        }
        break;
      default:
        break;
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await fetchData(
        "districts",
        "GET",
        null,
        {},
        {},
        navigate,
        "/districts",
        dispatch
      );
      setDistricts(response?.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const fetchTehsils = async () => {
    if (!selectedDistrict) return;
    try {
      const response = await fetchData(
        "tehsils",
        "GET",
        null,
        {},
        { district_id: selectedDistrict },
        navigate,
        "/tehsils",
        dispatch
      );
      setTehsils(response?.data || []);
    } catch (error) {
      console.error("Error fetching tehsils:", error);
    }
  };

  const fetchUcs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "ucs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil },
        navigate,
        "/ucs",
        dispatch
      );
      setUcs(response?.data || []);
    } catch (error) {
      console.error("Error fetching UCs:", error);
    }
  };

  const fetchDehs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "dehs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil },
        navigate,
        "/dehs",
        dispatch
      );
      setDehs(response?.data || []);
    } catch (error) {
      console.error("Error fetching Dehs:", error);
    }
  };

  const fetchVillages = async () => {
    if (!selectedDeh) return;
    try {
      const response = await fetchData(
        "villages",
        "GET",
        null,
        {},
        { deh_id: selectedDeh },
        navigate,
        "/villages",
        dispatch
      );
      setVillages(response?.data || []);
    } catch (error) {
      console.error("Error fetching Villages:", error);
    }
  };

  const fetchWashInformation = async () => {
    try {
      const response = await fetchData(
        "wash-information",
        "GET",
        null,
        {},
        {
          page: pagination.current_page,
          limit: pagination.per_page,
          search: debouncedSearch || undefined,
          district_id: appliedDistrict || undefined,
          tehsil_id: appliedTehsil || undefined,
          uc_id: appliedUc || undefined,
          deh_id: appliedDeh || undefined,
          village_id: appliedVillages || undefined,
          date_field: appliedDateField || undefined,
          condition: appliedCondition || undefined,
          date_value: appliedDateValue || undefined,
          start_date: appliedStartDate || undefined,
          end_date: appliedEndDate || undefined,
          verified_from_dqa: appliedDqaStatus || undefined,
        },
        navigate,
        "/wash",
        dispatch
      );

      setWashData(response?.data?.wash_information || []);
      setPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error("Error fetching wash information:", error);
    }
  };

  const fetchAllWashDataForExport = async () => {
    try {
      const response = await fetchData(
        "combined-wash-data",
        "GET",
        null,
        {},
        {
          page: 1,
          limit: 10000,
          search: debouncedSearch || undefined,
          district_id: appliedDistrict || undefined,
          tehsil_id: appliedTehsil || undefined,
          uc_id: appliedUc || undefined,
          deh_id: appliedDeh || undefined,
          village_id: appliedVillages || undefined,
          date_field: appliedDateField || undefined,
          condition: appliedCondition || undefined,
          date_value: appliedDateValue || undefined,
          start_date: appliedStartDate || undefined,
          end_date: appliedEndDate || undefined,
          verified_from_dqa: appliedDqaStatus || undefined,
        },
        navigate,
        "/wash",
        dispatch
      );

      return response?.data || {};
    } catch (error) {
      console.error("Error fetching all wash data for export:", error);
      throw error;
    }
  };

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const exportData = await fetchAllWashDataForExport();

      if (
        !exportData.wash_information ||
        exportData.wash_information.length === 0
      ) {
        toast.warning("No data available to export based on current filters.");
        return;
      }
      const wb = XLSX.utils.book_new();
      if (
        exportData.wash_information &&
        exportData.wash_information.length > 0
      ) {
        const waterSheetData = exportData.wash_information
          .filter(
            (info) => info.wash_type === "water" || info.wash_type === "both"
          )
          .map((info) => {
            const water =
              exportData.wash_water?.find(
                (w) => w.wash_information_id === info.wash_information_id
              ) || {};
            return {
              District: info.district_name || "N/A",
              Tehsil: info.tehsil_name || "N/A",
              UC: info.uc_name || "N/A",
              Deh: info.deh_name || "N/A",
              Village: info.village_name || "N/A",
              "Wash ID": info.wash_information_id,
              "Survey Date": info.date_time_of_survey
                ? new Date(info.date_time_of_survey).toLocaleDateString()
                : "N/A",
              "Respondent Name": info.respondent_name || "N/A",
              "Respondent CNIC": info.respondent_cnic || "N/A",
              "Line Number": info.respondent_line_number || "N/A",
              Role: info.respondent_role || "N/A",
              "Role Other": info.respondent_role_other || "N/A",
              Status: info.status === 1 ? "Active" : "Inactive",
              "DQA Approved": info.verified_from_dqa === 1 ? "Yes" : "No",
              "DQA Approval Date": info.verified_from_dqa_datetime
                ? new Date(info.verified_from_dqa_datetime).toLocaleDateString()
                : "N/A",
              "Rejection Remarks": info.rejection_remarks || "N/A",
              "Water ID": water?.wash_water_id || "N/A",
              Number: water?.number || "N/A",
              "Water Source Type": water?.type_of_water_source || "N/A",
              Use: water?.use || "N/A",
              "Use for Irrigation": water?.use_for_irrigation || "N/A",
              "Water Status": water?.water_status || "N/A",
              "Non-functional Since":
                water?.water_status_non_functional_since || "N/A",
              "Hours Used": water?.water_used_in_hours || "N/A",
              Reliability: water?.reliability_of_water_source || "N/A",
              Ownership: water?.ownership || "N/A",
              "Year Installed": water?.year_of_installation || "N/A",
              Accessibility: water?.accessibility || "N/A",
              "Quality Monitoring": water?.water_quality_monitoring || "N/A",
              "Water Quality": water?.water_quality || "N/A",
              "O&M": water?.operation_maintenance || "N/A",
              "Number of People": water?.number_of_people || "N/A",
              "People Roles": water?.roles_of_people || "N/A",
              "Yearly Expenditure": water?.total_yearly_expenditure || "N/A",
              "Maintenance Frequency": water?.maintenance_frequency || "N/A",
              "Water Fees": water?.water_fees || "N/A",
              "Fees in PKR": water?.water_fees_in_pkr || "N/A",
              "Fees Percentage": water?.water_fees_percentage || "N/A",
              "Past Floods": water?.past_floods || "N/A",
              "Other Water Source": water?.other_source_of_water_use || "N/A",
              "Other Source Details": water?.other_source_specify || "N/A",
              "Other Source Functionality":
                water?.other_source_functionality || "N/A",
              "Other Source People": water?.other_source_people || "N/A",
              "Rain Water Pits": water?.pits_for_rain_water || "N/A",
              "Waterborne Disease": water?.waterborne_disease || "N/A",
              "Hygiene Promotion": water?.hygiene_promotion || "N/A",
              "Hygiene Promotion Specify":
                water?.hygiene_promotion_specify || "N/A",
              "Hygiene Promotion Other":
                water?.hygiene_promotion_other || "N/A",
              "Disposal of Latrine Waste":
                water?.disposal_of_latrine_waste || "N/A",
              "Septic Tanks": Array.isArray(water?.septic_tanks)
                ? water.septic_tanks.join(", ")
                : water?.septic_tanks || "N/A",
            };
          });

        if (waterSheetData.length > 0) {
          const ws1 = XLSX.utils.json_to_sheet(waterSheetData);
          XLSX.utils.book_append_sheet(wb, ws1, "Wash Water");
        }
      }
      if (
        exportData.wash_information &&
        exportData.wash_information.length > 0
      ) {
        const sanitationSheetData = exportData.wash_information
          .filter(
            (info) =>
              info.wash_type === "sanitation" || info.wash_type === "both"
          )
          .map((info) => {
            const sanitation =
              exportData.wash_sanitation?.find(
                (s) => s.wash_information_id === info.wash_information_id
              ) || {};

            let lastEmptiedMethod = "N/A";
            let lastEmptiedSpecify = "N/A";
            let emptiedByHouseholdDisposal = "N/A";
            let removedByServiceProvider = "N/A";
            let removedByServiceProviderDisposal = "N/A";
            let removedByServiceProviderOther = "N/A";

            if (sanitation.last_time_emptied) {
              try {
                const parsed =
                  typeof sanitation.last_time_emptied === "string"
                    ? JSON.parse(sanitation.last_time_emptied)
                    : sanitation.last_time_emptied;

                lastEmptiedMethod = parsed.method || "N/A";
                lastEmptiedSpecify = parsed.specify || "N/A";
                emptiedByHouseholdDisposal = parsed.household_disposal || "N/A";
                removedByServiceProvider = parsed.service_provider || "N/A";
                removedByServiceProviderDisposal =
                  parsed.service_provider_disposal || "N/A";
                removedByServiceProviderOther =
                  parsed.service_provider_other || "N/A";
              } catch (e) {
                lastEmptiedMethod = sanitation.last_time_emptied;
              }
            }

            return {
              District: info.district_name || "N/A",
              Tehsil: info.tehsil_name || "N/A",
              UC: info.uc_name || "N/A",
              Deh: info.deh_name || "N/A",
              Village: info.village_name || "N/A",
              "Wash ID": info.wash_information_id,
              "Survey Date": info.date_time_of_survey
                ? new Date(info.date_time_of_survey).toLocaleDateString()
                : "N/A",
              "Respondent Name": info.respondent_name || "N/A",
              "Respondent CNIC": info.respondent_cnic || "N/A",
              "Line Number": info.respondent_line_number || "N/A",
              Role: info.respondent_role || "N/A",
              "Role Other": info.respondent_role_other || "N/A",
              Status: info.status === 1 ? "Active" : "Inactive",
              "DQA Approved": info.verified_from_dqa === 1 ? "Yes" : "No",
              "DQA Approval Date": info.verified_from_dqa_datetime
                ? new Date(info.verified_from_dqa_datetime).toLocaleDateString()
                : "N/A",
              "Rejection Remarks": info.rejection_remarks || "N/A",
              "Sanitation ID": sanitation?.wash_sanitation_id || "N/A",
              Number: sanitation?.number || "N/A",
              "Toilet Type": sanitation?.type_of_toilet || "N/A",
              "Toilet Status": sanitation?.status_of_toilet || "N/A",
              "Non-functional Since": sanitation?.non_functional_since || "N/A",
              Ownership: sanitation?.ownership || "N/A",
              "Year Built": sanitation?.year_of_construction || "N/A",
              Accessibility: sanitation?.accessibility || "N/A",
              "Cultural Gender": sanitation?.cultural_gender || "N/A",
              "Pit Latrines": sanitation?.has_pit_latrines || "N/A",
              "Last Emptied Method": lastEmptiedMethod,
              "Last Emptied Specify": lastEmptiedSpecify,
              "Emptied By Household Disposal": emptiedByHouseholdDisposal,
              "Removed By Service Provider": removedByServiceProvider,
              "Removed By Service Provider Disposal":
                removedByServiceProviderDisposal,
              "Removed By Service Provider Other":
                removedByServiceProviderOther,
              "Flood Affected": sanitation?.affected_by_floods || "N/A",
              Handwashing: sanitation?.functional_handwashing || "N/A",
              "Soap Available": sanitation?.soap_detergent_available || "N/A",
              "Hygiene Promotion": sanitation?.hygiene_promotion || "N/A",
              "Hygiene Details": sanitation?.hygiene_promotion_specify || "N/A",
              "Hygiene Other": sanitation?.hygiene_promotion_other || "N/A",
              "Waste Disposal": sanitation?.disposal_of_latrine_waste || "N/A",
              "Septic Tanks": Array.isArray(sanitation?.septic_tanks)
                ? sanitation.septic_tanks.join(", ")
                : sanitation?.septic_tanks || "N/A",
            };
          });

        if (sanitationSheetData.length > 0) {
          const ws2 = XLSX.utils.json_to_sheet(sanitationSheetData);
          XLSX.utils.book_append_sheet(wb, ws2, "Wash Sanitation");
        }
      }
      const currentDate = new Date().toISOString().split("T")[0];
      const appliedDistrictName =
        districts.find((d) => d.district_id === appliedDistrict)
          ?.district_name || "";
      const appliedVillageName =
        villages.find((v) => v.village_id === appliedVillages)?.village_name ||
        "";

      let filename = `wash-data-${currentDate}`;
      if (appliedDistrictName) filename += `-${appliedDistrictName}`;
      if (appliedVillageName) filename += `-${appliedVillageName}`;
      filename += ".xlsx";
      XLSX.writeFile(wb, filename);
      toast.success("Excel file exported successfully!");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Failed to export data to Excel");
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);
  useEffect(() => {
    fetchTehsils();
  }, [selectedDistrict]);
  useEffect(() => {
    fetchUcs();
  }, [selectedTehsil]);
  useEffect(() => {
    fetchDehs();
  }, [selectedTehsil]);
  useEffect(() => {
    fetchVillages();
  }, [selectedDeh]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setPagination((prev) => ({ ...prev, current_page: 1 }));
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchWashInformation();
  }, [
    debouncedSearch,
    appliedDistrict,
    appliedTehsil,
    appliedUc,
    appliedDeh,
    appliedVillages,
    appliedDqaStatus,
    appliedDateField,
    appliedCondition,
    appliedDateValue,
    appliedStartDate,
    appliedEndDate,
    pagination.current_page,
    pagination.per_page,
  ]);

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, per_page: size, current_page: 1 }));
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, current_page: value }));
  };

  const handleDelete = async () => {
    setModalVisible(false);
    setWashData((prev) =>
      prev.filter((wash) => wash.wash_information_id !== selectedUuid)
    );
    try {
      const response = await fetchData(
        `wash-information/${selectedUuid}`,
        "DELETE",
        { id: selectedUuid },
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );
      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to delete the wash information."
        );
      }
      toast.success("Wash information deleted successfully.");
    } catch (error) {
      console.error("Error deleting wash information:", error);
      toast.error(
        error?.message ||
          "An error occurred while deleting the wash information."
      );
      fetchWashInformation();
    }
  };
  const handleReject = async () => {
    setRejectModalVisible(false);
    setRemarksModalVisible(true);
  };
  const handleSubmitRemarks = async () => {
    const validationError = validateRemarks(remarks);
    if (validationError) {
      setRemarksError(validationError);
      return;
    }

    try {
      const response = await fetchData(
        `wash-information-reject/${selectedRejectId}`,
        "PUT",
        { remarks: remarks.trim(), verified_from_dqa_status: 2 },
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to reject the wash information."
        );
      }

      await fetchWashInformation();
      toast.success("Wash information rejected successfully.");

      const currentDateTime = new Date().toISOString();
      setWashData((prev) =>
        prev.map((item) =>
          item.wash_information_id === selectedRejectId
            ? {
                ...item,
                verified_from_dqa: 2,
                verified_from_dqa_datetime:
                  response.data?.verified_from_dqa_datetime || currentDateTime,
                rejection_remarks: remarks.trim(),
              }
            : item
        )
      );

      setRemarksModalVisible(false);
      setRemarks("");
      setRemarksError("");
    } catch (error) {
      console.error("Error rejecting wash information:", error);
      toast.error(
        error?.message ||
          "An error occurred while rejecting the wash information."
      );
    }
  };
  const handleCancelRemarks = () => {
    setRemarksModalVisible(false);
    setRemarks("");
    setRemarksError("");
  };

  const handleApprove = async () => {
    setApproveModalVisible(false);
    try {
      const response = await fetchData(
        `wash-information-approve/${selectedApproveId}`,
        "PUT",
        {},
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to approve the wash information."
        );
      }

      toast.success("Wash information approved successfully.");

      const currentDateTime = new Date().toISOString();
      setWashData((prev) =>
        prev.map((item) =>
          item.wash_information_id === selectedApproveId
            ? {
                ...item,
                verified_from_dqa: 1,
                verified_from_dqa_datetime: currentDateTime,
              }
            : item
        )
      );
    } catch (error) {
      console.error("Error approving wash information:", error);
      toast.error(
        error?.message ||
          "An error occurred while approving the wash information."
      );
    }
  };

  const showDeleteModal = (id) => {
    setSelectedUuid(id);
    setModalVisible(true);
  };

  const showApproveModal = (id) => {
    setSelectedApproveId(id);
    setApproveModalVisible(true);
  };
  const showRejectModal = (id) => {
    setSelectedRejectId(id);
    setRejectModalVisible(true);
  };

  const formatApprovalDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;

    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTimeForDisplay = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    const date = new Date(dateTimeString);
    if (isNaN(date)) return "N/A";

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
    });
  };

  const formatDateOnly = (dateTimeString) => {
    if (!dateTimeString) return "N/A";
    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // DD/MM/YYYY
  };

  const columns = [
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Respondent Name
        </span>
      ),
      minWidth: "180px",
      selector: (row) => row.respondent_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Respondent CNIC
        </span>
      ),
      selector: (row) => row.respondent_cnic || "N/A",
      sortable: true,
      minWidth: "180px",
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Date of Survey
        </span>
      ),
      selector: (row) => formatDateOnly(row.date_time_of_survey),
      sortable: true,
    },

    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">Village</span>
      ),
      selector: (row) => row.village_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Wash Type
        </span>
      ),
      selector: (row) => row.wash_type || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          DQA Approval
        </span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";

        const actionDateTime = formatApprovalDateTime(
          row.verified_from_dqa_datetime
        );

        return (
          <div className="text-center">
            {isApproved ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-blue-100 text-blue-800">
                  Approved
                </span>
                {actionDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {actionDateTime}
                  </div>
                )}
              </>
            ) : isRejected ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-red-100 text-red-800">
                  Rejected
                </span>
                {actionDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {actionDateTime}
                  </div>
                )}
              </>
            ) : (
              <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-yellow-100 text-yellow-800 ml-5">
                Pending
              </span>
            )}
          </div>
        );
      },
    },
  ];
  if (
    permissions.includes("wash-information-update") ||
    permissions.includes("wash-information-delete") ||
    permissions.includes("wash-information-approve") ||
    permissions.includes("wash-information-reject")
  ) {
    columns.push({
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">Action</span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
        const hasRemarks = getLatestRemarks(row) !== "No remarks";

        return (
          <div className="flex gap-1">
            {hasRemarks && (
              <button
                onClick={() => showRemarksDialog(row)}
                title="View Remarks"
                className="text-blue-600 hover:text-blue-800 hover:scale-110 transition-transform"
              >
                <i className="fa-solid fa-comment fa-lg"></i>
              </button>
            )}

            <PermissionButton
              hasPermission={permissions.includes("wash-information-update")}
              to={`/wash/edit/${row.wash_information_id}`}
              faIcon={
                isApproved || isRejected
                  ? "fa-solid fa-eye fa-lg"
                  : "fa-solid fa-pen-to-square fa-lg"
              }
              onlyIcon
              enabledClass=""
              disabledClass="opacity-50 cursor-not-allowed"
            />
            {permissions.includes("wash-information-approve") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showApproveModal(row.wash_information_id)}
                  title="Approve"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-check-circle fa-lg text-green-600 hover:text-green-800"></i>
                </button>
              )}
            {permissions.includes("wash-information-reject") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showRejectModal(row.wash_information_id)}
                  title="Reject"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-times-circle fa-lg text-red-600 hover:text-red-800"></i>
                </button>
              )}
            {permissions.includes("wash-information-delete") && !isApproved && (
              <PermissionButton
                hasPermission={permissions.includes("wash-information-delete")}
                faIcon="fa fa-trash fa-lg text-primaryDark"
                onlyIcon
                onClick={() => showDeleteModal(row.wash_information_id)}
                className="p-1 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                enabledClass=""
                disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
              />
            )}
          </div>
        );
      },
    });
  }

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  if (!permissions.includes("wash-information-view")) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Unauthorized Access
        </h2>
        <p className="text-gray-500">
          You do not have permission to view this section.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="my-4 flex justify-between items-center">
        <h1 className="text-[1.475rem] text-[#212529] font-[Bold]">
          Wash Information
        </h1>

        {hasDataToExport && (
          <button
            onClick={exportToExcel}
            disabled={isExporting}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              isExporting
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-[#137e81] text-white hover:bg-[#0f6c6f] hover:scale-105"
            }`}
            title="Export filtered data to Excel"
          >
            <Download size={18} />
            {isExporting ? "Exporting..." : "Export Excel"}
          </button>
        )}
      </div>
      <Accordion>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#ffff" size={14} />
            ) : (
              <Plus size={14} color="#ffff" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "#137e81",
            color: "#fff !important",
            "& .MuiAccordionSummary-content": {
              color: "#fff  !important",
            },
          }}
          onClick={toggleFilters}
        >
          Filters
        </AccordionSummary>

        <AccordionDetails>
          <div className="space-y-4">
            {/* ========== First row: 4 dropdowns ========== */}
            <div className="flex gap-5 w-full">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`district-${filterReset}`}
                  label="District"
                  id="district-dropdown"
                  options={districts?.map((dis) => ({
                    value: dis?.district_id,
                    label: dis?.district_name,
                  }))}
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`tehsil-${filterReset}`}
                  label="Tehsil"
                  id="tehsil-dropdown"
                  options={tehsils?.map((tehsil) => ({
                    value: tehsil?.tehsil_id,
                    label: tehsil?.tehsil_name,
                  }))}
                  value={selectedTehsil}
                  onChange={handleTehsilChange}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`deh-${filterReset}`}
                  label="Deh"
                  id="deh-dropdown"
                  options={dehs?.map((deh) => ({
                    value: deh?.deh_id,
                    label: deh?.deh_name,
                  }))}
                  value={selectedDeh}
                  onChange={handleDehChange}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`village-${filterReset}`}
                  label="Village"
                  id="village-dropdown"
                  options={villages?.map((Village) => ({
                    value: Village?.village_id,
                    label: Village?.village_name,
                  }))}
                  value={selectedVillages}
                  onChange={handleVillageChange}
                />
              </div>
            </div>

            {/* ========== Second row: DQA + Date filters ========== */}
            <div className="flex gap-5 w-full items-end">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="DQA Status"
                  id="dqa-status-dropdown"
                  options={dqaStatusOptions}
                  value={selectedDqaStatus}
                  onChange={(value) => setSelectedDqaStatus(value)}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Date Field"
                  id="date-field-dropdown"
                  options={dateFieldsOptions}
                  value={dateField}
                  onChange={(value) => handleFilterChange("dateField", value)}
                />
              </div>

              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Condition"
                  id="condition-dropdown"
                  options={conditions}
                  value={condition}
                  onChange={(value) => handleFilterChange("condition", value)}
                  disabled={!dateField}
                />
              </div>

              {condition === "between" ? (
                <>
                  <div className="flex-1">
                    <ThinTextField isRequired={false}
                      label="Start Date"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="flex-1">
                    <ThinTextField isRequired={false}
                      label="End Date"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </>
              ) : (
                <div className="flex-1">
                  <ThinTextField isRequired={false}
                    label="Date Value"
                    type="date"
                    value={dateValue}
                    onChange={(e) => setDateValue(e.target.value)}
                    disabled={!condition || condition === "between"}
                  />
                </div>
              )}
            </div>
          </div>

          {/* ========== Action buttons ========== */}
          <div className="flex gap-2 mt-4 justify-end">
            <button
              onClick={handleClear}
              className="px-4 py-2 bg-[#be9609] text-white rounded-lg hover:bg-[#a68108] transition-colors"
            >
              Clear
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 bg-[#137e81] text-white rounded-lg hover:bg-[#0f6c6f] transition-colors"
            >
              Apply
            </button>
          </div>
        </AccordionDetails>
      </Accordion>

      <div className="rounded-lg my-[15px] shadow w-full bg-white">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Manage Wash Information
          </h1>

          {(hasFiltersApplied || search) && (
            <div className="text-sm text-gray-600">
              {pagination.total_records} records found
              {hasDataToExport && (
                <span className="ml-2 text-green-600 font-medium">
                  • Export available
                </span>
              )}
            </div>
          )}
        </div>

        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start gap-2 lg:items-center items-start mb-[6px] w-full">
            <PaginationDropdown
              value={pagination.per_page}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />

            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              placeholder="Search..."
              type="search"
              className="font-[Light] text-[14px] flex items-center bg-[#f1f4f8] border-[#ebeef2] border-[1px] rounded-md px-3 py-1 outline-none"
            />
          </div>
          <DataTable
            columns={columns}
            data={washData}
            persistTableHead
            customStyles={customStyles}
            highlightOnHover
            progressPending={false}
          />
          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={washData.length}
          />
        </div>
      </div>
      <CustomConfirmModal
        isVisible={isModalVisible}
        onConfirm={handleDelete}
        onCancel={() => setModalVisible(false)}
        message="Are you sure you want to delete this Wash Information?"
      />
      <CustomConfirmModal
        isVisible={isApproveModalVisible}
        onConfirm={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
        message="Are you sure you want to approve this Wash Information from DQA?"
      />
      <CustomConfirmModal
        isVisible={isRejectModalVisible}
        onConfirm={handleReject}
        onCancel={() => setRejectModalVisible(false)}
        message="Are you sure you want to reject this Wash Information from DQA?"
      />
      <Dialog
        open={isViewRemarksModalVisible}
        onClose={closeRemarksDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Remarks History
          {selectedWashForRemarks && (
            <Typography
              variant="subtitle1"
              sx={{ color: "white", fontSize: "0.9rem", mt: 1 }}
            >
              Wash ID: {selectedWashForRemarks.wash_information_id} -{" "}
              {selectedWashForRemarks.respondent_name}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", maxHeight: "60vh" }}>
          {selectedWashForRemarks && (
            <Box>
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                }}
              >
                <Typography variant="h6" sx={{ mb: 1, color: "#137e81" }}>
                  {/* Current Remarks */}
                </Typography>
              </Box>

              {getRemarksHistory(selectedWashForRemarks).length > 0 ? (
                <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                  {getRemarksHistory(selectedWashForRemarks).map(
                    (history, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          backgroundColor: index === 0 ? "#f0f8ff" : "white",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold", color: "#333" }}
                          ></Typography>
                          <Typography variant="caption" sx={{ color: "#666" }}>
                            {formatDateTimeForDisplay(history.date)}
                          </Typography>
                        </Box>

                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2">
                            <strong>Remarks:</strong>{" "}
                            <span
                              style={{ color: "#2e7d32", fontWeight: "bold" }}
                            >
                              {history.to}
                            </span>
                          </Typography>
                        </Box>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", mt: 1, display: "block" }}
                        >
                          User Name: {history.userName}
                        </Typography>
                      </Box>
                    )
                  )}
                </Box>
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", color: "#666", py: 3 }}
                >
                  No remarks history available
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={closeRemarksDialog}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Rejection Remarks Modal */}
      <Dialog
        open={isRemarksModalVisible}
        onClose={handleCancelRemarks}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Rejection Remarks
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "8px",
                color: "#333",
                fontWeight: "500",
              }}
            >
              Please provide the reason for rejection:
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#666",
                fontStyle: "italic",
              }}
            >
              Remarks must be between 10 and 255 characters.
            </Typography>
          </Box>
          <TextField
            autoFocus
            label="Remarks"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={(e) => handleRemarksChange(e.target.value)}
            placeholder="Enter detailed reason for rejection (minimum 10 characters, maximum 255 characters)..."
            variant="outlined"
            error={!!remarksError}
            helperText={
              remarksError ||
              `${remarks.trim().length}/255 characters` +
                (remarks.trim().length > 0
                  ? ` (${
                      remarks.trim().length < 10
                        ? `${10 - remarks.trim().length} more required`
                        : "valid length"
                    })`
                  : "")
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#137e81",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#137e81",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#137e81",
              },
              "& .MuiFormHelperText-root": {
                color: remarksError ? "#d32f2f" : "#666",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", gap: "8px" }}>
          <Button
            onClick={handleCancelRemarks}
            color="secondary"
            variant="outlined"
            sx={{
              borderColor: "#6c757d",
              color: "#6c757d",
              "&:hover": {
                borderColor: "#545b62",
                backgroundColor: "rgba(108, 117, 125, 0.04)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitRemarks}
            color="primary"
            variant="contained"
            disabled={
              !remarks.trim() ||
              remarks.trim().length < 10 ||
              remarks.trim().length > 255
            }
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
              "&:disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
          >
            Submit Rejection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Wash;
